export const HIGHLIGHT_DATA_ID = 'data-mark-id';
export const HIGHLIGHT_TAG_NAME = 'mark';
// tiptap extension
export const HIGHLIGHT_EXTENSION_NAME = 'highlightMark';
// prosemirror view plugin
export const HIGHLIGHT_VIEW_PLUGIN_NAME = 'highlightView';
